module.exports = __webpack_public_path__ + "img/107ne.07ead45b.svg";